import { Component, OnInit, Input, EventEmitter, Output, HostListener, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, FormGroupDirective, ValidationErrors } from '@angular/forms';
import { SEMICOLON, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router } from '@angular/router';
import { ValidationConstants as validationConstants } from './validation_constants';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { debounceTime, distinctUntilChanged, Observable } from 'rxjs';
import { CandidateCreateConstants } from '../constants/candidate-create-constants';
import { OrgBasedCandidateForm } from '../constants/org-forms-constants/org-based-forms-model';
import { TelephoneCodeConstants } from '../constants/telephone-code-constants';
import { OnboardService } from '../shared/service/onboard-service';
import { FileUploadUtil } from '../shared/utils/candidate/file-upload-util';
import { OnboardFormsUtil } from './onboard-forms-util';
import { OrgBasedOnboardForm } from '../shared/service/IorgBasedForms';
import { ZipFileDownloadDialog } from '../zip-file-download/zip-file-download-dialog.component';
import { TabRestrictDialog } from '../tab-restrict-dialog/tab-restrict-dialog.component';
import { FormSubmissionErrorsDialog } from '../shared/dialogs/form-submission-error-dialog/form-submission-error-dialog';
import { ValidationHighlightsUtil } from '../shared/utils/candidate/validation-highlights';
import { GoToOriginalDialog } from '../shared/dialogs/goto-original-dialog/goto-original-dialog.component';
import { UserService } from '../shared/service/user-service';
import { LocalStorageUtil } from '../shared/utils/local-storage/local-storage-util';
import { uniqueNameInFormArrayValidator } from '../shared/utils/candidate/customasyncvalidators';
import { compareFormValuesFromUtil, getDirtyFieldsFromUtil } from '../shared/utils/candidate/form-comparison.utils';
import { SkipFieldConstants } from '../constants/skipfields-constants';
import { SnackbarConstants } from '../constants/snackbar-constants';
import { SnackBarUtil } from '../shared/utils/snackbar/snackbar-util';

export interface Fruit {
  name: string;
}

export interface ICountryAndCode {
  code: string;
  name: string;
  isoCode: string;
}

@Component({
  selector: 'app-onboard-create',
  templateUrl: './onboard-create.component.html',
  styleUrls: ['./onboard-create.component.scss'],
})

export class OnboardCreateComponent implements OnInit, OnChanges {
  @ViewChild('refdialcodeSearch') refdialcodeSearch: ElementRef;
  rowInfo: any;
  @Input() formIndex: any;
  @Input() downloadAllFiles: any;
  rowInfoMasterData: any;
  clear = false;
  editable: boolean = false;
  fileeditable: boolean = false; //compensation tab edit button
  candidates: any = {};
  selected = [];
  onboardCreateForm: FormGroup;
  panelOpenState: boolean = true;
  public fieldArrayEducation: Array<any> = [{}];
  public fieldArraySkills: Array<any> = [{}];
  public fieldArrayExperience: Array<any> = [{}];
  Hobbies: Array<string> = [];
  workedPreviouslyFlag: boolean = false;
  relativeWorkingFlag: boolean = false;
  medicalAilmentsFlag: boolean = false;
  orgBasedOnboardFormsJson: OrgBasedOnboardForm;
  preonboardfilesuploaded: any
  designations: string[] = [
    'Contract',
    'Consultant',
    'Executive',
    'Sr. Executive',
    'AVP',
    'VP'
  ];
  saluteOptions: string[] = CandidateCreateConstants.SALUTATION_OPTIONS;
  gender = CandidateCreateConstants.GENDER;
  degrees: string[] = CandidateCreateConstants.DEGREE;
  types: string[] = CandidateCreateConstants.EMPLOYMENT_TYPES;
  proficiencys: any[] = CandidateCreateConstants.PROFICIENCY;
  atypes: string[] = CandidateCreateConstants.EDUCATION_TYPES;
  nations: string[] = CandidateCreateConstants.NATION;
  // dialCodes: { name: string, code: string, isoCode: string }[] = TelephoneCodeConstants.TELEPHONE_CODE;
  dialCodes: ICountryAndCode[] = TelephoneCodeConstants.TELEPHONE_CODE;
  countryCode: ICountryAndCode;

  maritalstatus = [{ value: 'Single', viewValue: 'Single' },
  { value: 'Married', viewValue: 'Married' },
  { value: 'Divorce', viewValue: 'Divorce' }]
  options: string[] = CandidateCreateConstants.SALUTATION_OPTIONS;
  // options: string[] = [];

  skills1: string[] = ['Learner', 'Intermediate', 'Expert'];
  orgBasedCandidateFormsJson: OrgBasedCandidateForm;
  aTtachment: any = [];
  filecount: number;
  attachmentEducation: any = [];
  attachmentExperience: any = [];
  attachmentCategory: any = [];
  // orgBasedInterviewFormsJson: OrgBasedInterviewForm;
  JWTPrivilegesArray: Array<string>;
  loggedInUsername: string;
  loggedInCandidateId: any;
  loggedInOrgID: any;
  loggedInTenantID: any; //org details
  loggedInUserrole: any;
  loggedInUserName: any;

  afterDecrypting: any;
  OrganizationPreloadsInfo = {
    currency: ['SAR'],
    defaultcountrycode: '+966',
    preferredcurrency: 'SAR'
  }
  //loader 
  isLoaderEnabled: boolean = false;
  // countryCode: any;
  chipLength = 7;
  errorFields = [];
  showErrorFields: boolean = false;
  initialFormValue: any;

  bloodgroup: string[] = [
    ' AB +', 'AB -', 'O +', 'O -', 'A +', ' A -', 'B +', 'B -'
  ];

  currencies: string[] = [
    "SAR",
    "USD",
    "AUD",
    "BHD",
    "BRL",
    "CAD",
    "CLP",
    "COP",
    "CZK",
    "DKK",
    "EGP",
    "HKD",
    "HUF",
    "ISK",
    "INR",
    "IDR",
    "ILS",
    "JPY",
    "JOD",
    "KES",
    "KRW",
    "KWD",
    "MYR",
    "MAD",
    "MXN",
    "NZD",
    "NOK",
    "OMR",
    "PHP",
    "PLN",
    "QAR",
    "SGD",
    "ZAR",
    "SEK",
    "CHF",
    "THB",
    "TND",
    "TRY",
    "AED",
    "VND",
  ]
  nationsList: Observable<String[]>;
  minDate: Date;
  maxDate: Date;
  selectedDate: Date;
  //after action send status to listview
  @Output() rowInfoTrigger = new EventEmitter<any>();
  public innerWidth: any;
  updatedRowInfoTrigger($event) {
    this.rowInfoTrigger.emit($event);
  }
  cachedData: any;
  cachedurl: any = '';
  currentDisplayLanguage: string = 'en';
  skipFieldsForCheckForm = SkipFieldConstants.ONBOARD_FORM;
  dateFormFields = SkipFieldConstants.ONBOARD_DATE_FORM;

  constructor(private onboardService: OnboardService, private userService: UserService, private validationHighlightsUtil: ValidationHighlightsUtil,private snackBarUtil: SnackBarUtil,
    private datePipe: DatePipe, public dialog: MatDialog, private formBuilder: FormBuilder,
    private router: Router, private _router: Router, public onboardFormsUtil: OnboardFormsUtil, public fileUploadUtil: FileUploadUtil,
    public snackBar: MatSnackBar, private localStorageUtil: LocalStorageUtil) {
    this.candidates = null;
    //Rolebased Authorization
    let accesstoken = this.localStorageUtil.getAccessToken();
    //Setting Username
    this.loggedInUsername = accesstoken.loggedInUsername;
    this.loggedInOrgID = accesstoken.loggedInOrgID;
    this.loggedInCandidateId = accesstoken.candidateid;
    this.currentDisplayLanguage = sessionStorage.getItem('currentlanguage') || 'en';

    const cachedRequestBody = sessionStorage.getItem('requestBody');
    if (cachedRequestBody) {
      this.cachedData = JSON.parse(cachedRequestBody);
      let cachedRequest = sessionStorage.getItem('cachedRequests');
      if (cachedRequest) {
        let decodedRequest = JSON.parse(cachedRequest);
        this.cachedurl = decodedRequest.url
      }
    }
    this.setOrganisationPreloads(this.OrganizationPreloadsInfo);
    //DOB validation
    //DOB validation
    this.maxDate = new Date();
    this.minDate = new Date();
    this.minDate.setFullYear(this.minDate.getFullYear() - 99); //For block previous date
    // Dynamically Updating Snapshot - OBSERVABLE
    this.onboardService.discardDatastring$?.subscribe((data: any) => {
      if (data && data.action === 'discard') {
        if (data.index === 1) {
          this.cancelOnboardEdit();
        }
        else if (data.index === 2) {
          this.cancelFileEdit('compensationdetails');
          this.compensationdoceditable = false;
        }
        else if (data.index === 3) {
          this.cancelFileEdit('idattachments');
          this.iddoceditable = false;
        }
        else if (data.index === 4 || data.index === 5) {
          this.cancelFileEdit('eduexpattachments');
          this.eduexpdoceditable = false;
        }
        else if (data.index === 6) {
          this.cancelFileEdit('forms');
          this.formsdoceditable = false;
        }
      }
    });
    // Dynamically Updating Snapshot - OBSERVABLE
    this.onboardService.isDownloadstring$?.subscribe((data: any) => {
      if (data === true) {
        this.downloadAllFilesAsZip()
      }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formIndex']) {
      const previousValue = changes['formIndex'].previousValue;
      const currentValue = changes['formIndex'].currentValue;
      if (currentValue == 1 && previousValue !== undefined) {
        this.patchInfoForViewMode();
      }
      // Perform any action needed when formIndex changes
    }
  }

  getOnboardData() {
    this.onboardService.getOnboardData(this.loggedInCandidateId, this.loggedInOrgID).subscribe(
      (response: any) => {
        if (response) {
          this.rowInfo = response;
          this.preonboardfilesuploaded = response.uploadedfiles;
          // this.rowInfo.uploadedfiles = response.uploadedfiles;

          if (this.rowinfoData === false) {
            this.patchInfoForViewMode();
          }

        }
      });
  }


  fromOthers: boolean = false;
  rowinfoData: boolean = false;
  ngOnInit() {
    //the variable innerWidth is assigned with the window's innerWidth
    if (window.innerWidth > 767) {
      this.innerWidth = true
    }
    else {
      this.innerWidth = false
    }
    this.createForm();
    //disable form 
    this.onboardCreateForm.disable();
    if (this.rowInfo != null) {
      this.rowInfoMasterData = JSON.parse(JSON.stringify(this.rowInfo));
      this.candidates = this.rowInfo;
      this.fromOthers = true;
      this.patchInfoForViewMode();
    }
    if (this.cachedData != null && this.cachedData != undefined && this.cachedData != '') {
      this.rowinfoData = true;
      if (this.cachedurl && this.cachedurl != '' && this.cachedurl.includes('cp/secure/onboard/updatecandidateindb')) {
        // Patch Form Values
        this.rowInfoMasterData = JSON.parse(JSON.stringify(this.cachedData));
        this.rowInfo = JSON.parse(JSON.stringify(this.cachedData));
        this.fromOthers = true;
        this.onboardCreateForm.enable();
        this.patchInfoForViewMode();
        // Enable Edit
        this.enableEdit();
      }
    }
    this.onboardCreateForm.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(200)) // Throttle updates to avoid frequent calls
      .subscribe(value => this.checkIfFormValueUpdated(value));
    this.getOnboardData();
  }

  initializeForm() {
    this.onboardCreateForm = this.formBuilder.group({
      id: new FormControl(''),
      candidateid: new FormControl(''),
      orgid: new FormControl(''),
      status: new FormControl(''),
      appid: new FormControl(''),
      bloodgroup: new FormControl('',),
      hobbies: new FormControl([]),
      created_by: new FormControl(''),
      createdon: new FormControl(''),
      modified_by: new FormControl(''),
      modifiedby: new FormControl(''),
      modified_on: new FormControl(''),
      //Identity Details
      identity: new FormGroup({
        ssn_no: new FormControl('', [Validators.maxLength(9), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
        passport_no: new FormControl('', [Validators.maxLength(9), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
        pancard_no: new FormControl('', [Validators.maxLength(10), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
        drivinglicense_no: new FormControl('', [Validators.maxLength(16), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)])
      }),
      //Financial Details 
      bank: new FormGroup({
        bankname_1: new FormControl('', []),
        bankaccountno_1: new FormControl('', [Validators.maxLength(30), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.minLength(5)]),
        ifsc_code_1: new FormControl('', [Validators.maxLength(11), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
        bankname_2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
        bankaccountno_2: new FormControl('', [Validators.maxLength(30), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.minLength(5)]),
        ifsc_code_2: new FormControl('', [Validators.maxLength(11), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
        bankname_3: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
        bankaccountno_3: new FormControl('', [Validators.maxLength(30), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.minLength(5)]),
        ifsc_code_3: new FormControl('', [Validators.maxLength(11), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)])
      }),
      //Reference 
      reference: this.formBuilder.array([]), // FormArray
      //Family 
      family: new FormGroup({
        //Father
        father_name: new FormControl('', [Validators.maxLength(90), Validators.pattern(validationConstants.REGEX_TEXT_TYPE2)]),
        father_dob: new FormControl(''),
        father_gender: new FormControl('Male'),
        father_address: new FormControl('', [Validators.maxLength(250), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5)]),
        // Mother
        mother_name: new FormControl('', [Validators.maxLength(90), Validators.pattern(validationConstants.REGEX_TEXT_TYPE2)]),
        mother_dob: new FormControl(''),
        mother_gender: new FormControl('Female'),
        mother_address: new FormControl('', [Validators.maxLength(250), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5)]),
        //Spouse
        spouse_name: new FormControl('', [Validators.maxLength(90), Validators.pattern(validationConstants.REGEX_TEXT_TYPE2)]),
        spouse_dob: new FormControl(''),
        spouse_gender: new FormControl(''),
        spouse_address: new FormControl('', [Validators.maxLength(250), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5)]),
        // Father-in-law
        fatherinlaw_name: new FormControl('', [Validators.maxLength(90), Validators.pattern(validationConstants.REGEX_TEXT_TYPE2)]),
        fatherinlaw_dob: new FormControl(''),
        fatherinlaw_gender: new FormControl('Male'),
        fatherinlaw_address: new FormControl('', [Validators.maxLength(250), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5)]),
        // Mother-in-law
        motherinlaw_name: new FormControl('', [Validators.maxLength(90), Validators.pattern(validationConstants.REGEX_TEXT_TYPE2)]),
        motherinlaw_dob: new FormControl(null),
        motherinlaw_gender: new FormControl('Female'),
        motherinlaw_address: new FormControl('', [Validators.maxLength(250), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5)]),
        // Siblings
        siblings: this.formBuilder.array([]), // FormArray
        //Children
        children: this.formBuilder.array([]) // FormArray
      }),
      //Languages
      language: this.formBuilder.array([]), // FormArray
      //Files
      compensationdetails: new FormGroup({
        latestsalarybreakup: new FormControl(''),
        bonuspayoutform: new FormControl(''),
        bankstatement: new FormControl(''),
        payslip1: new FormControl(''),
        payslip2: new FormControl(''),
        payslip3: new FormControl(''),
      }),
      idattachments: new FormGroup({
        pancard: new FormControl(''),
        ssn: new FormControl(''),
        photograph: new FormControl(''),
        passport: new FormControl(''),
        pancardmultipart: new FormControl(''),
        ssnmultipart: new FormControl(''),
        photographmultipart: new FormControl(''),
        passportmultipart: new FormControl(''),
        pancardtemploc: new FormControl(''),
        ssntemploc: new FormControl(''),
        photographtemploc: new FormControl(''),
        passporttemploc: new FormControl(''),
      }),
      eduexpattachments: new FormGroup({
        educationproof: this.formBuilder.array([]), // FormArray
        experienceproof: this.formBuilder.array([]) // FormArray
      }),
      forms: new FormGroup({
        employmentapplicationform: new FormControl(''),
        bgvform: new FormControl(''),
        joiningform: new FormControl(''),
        pfuan: new FormControl(''),
        medicalreport: new FormControl(''),
        conflictofinterestform: new FormControl(''),
        confidentialityform: new FormControl(''),
      }),
    });
  }

  // Check if form value has been updated
  checkIfFormValueUpdated(updatedFormValue: any): void {
    this.userService.setPreventData(this.onboardCreateForm.dirty);
    if (!this.initialFormValue) return;
    const dirtyFields = getDirtyFieldsFromUtil(this.onboardCreateForm, this.initialFormValue);
    if (dirtyFields.length == 0) {
      this.onboardCreateForm.markAsPristine();
      return;
    }
    dirtyFields.forEach((field) => {
      const changedFields = compareFormValuesFromUtil([field], this.initialFormValue, updatedFormValue, this.skipFieldsForCheckForm, this.dateFormFields);
      const control = this.onboardCreateForm.get(field);
      if (changedFields.length > 0 || this.skipFieldsForCheckForm.includes(field)) {
        control?.markAsDirty();
        //   this.userService.setPreventData(this.candidateCreateForm.dirty);

      } else {
        control?.markAsPristine();
        //   this.userService.setPreventData(this.candidateCreateForm.dirty);

      }
    });
  }

  currencyTypeVO: string[];
  setOrganisationPreloads(data) {
    this.currencyTypeVO = data.currency;
    this.options = data.salutation; // Salutation
  }

  trimFormControlValue(formcontrolname) {
    let trimmedvalue = this.onboardCreateForm.get(formcontrolname).value.trim();
    this.onboardCreateForm.get(formcontrolname).setValue(trimmedvalue);
    this.onboardCreateForm.get(formcontrolname).updateValueAndValidity();
  }

  patchInfoForViewMode() {
    this.editable = false;
    this.onboardCreateForm?.patchValue({
      id: this.rowInfo.id,
      orgid: this.rowInfo.orgid,
      status: this.rowInfo.status,
      appid: this.rowInfo.appid,
      bloodgroup: this.rowInfo.bloodgroup,
      hobbies: this.rowInfo.hobbies,
      created_by: this.rowInfo.created_by,
      createdon: this.rowInfo.createdon,
      modified_by: this.rowInfo.modified_by,
      modified_on: this.rowInfo.modified_on,
    });
    if (this.rowInfo.identity) {
      this.onboardCreateForm.patchValue({ identity: this.rowInfo.identity })
    }
    if (this.rowInfo.bank) {
      this.onboardCreateForm.patchValue({ bank: this.rowInfo.bank })
    }
    // Reference tab
    if (this.rowInfo.reference) {
      this.reference = this.clearFormArray(this.onboardCreateForm.get('reference') as FormArray);
      // while (this.reference.length !== 0) { this.reference.removeAt(0) }
      this.rowInfo.reference.forEach(element => {
        this.reference.push(this.onboardFormsUtil.addNewReferenceFormArrayFieldBasedOnData(element))
        this.splitPhoneNumberForFormArray('contact', 'reference', this.reference.length - 1);
      });
    }
    if (this.rowInfo.family) {
      let father_dob;
      let mother_dob;
      let spouse_dob;
      let fatherinlaw_dob;
      let motherinlaw_dob;
      if (this.rowInfo.family.father_dob !== '' && this.rowInfo.family.father_dob !== ' ' && this.rowInfo.family.father_dob != null && this.rowInfo.family.father_dob != undefined) {
        let formatedFather_dob = this.datePipe.transform(this.rowInfo.family.father_dob, 'yyyy-MM-dd');
        father_dob = new Date(`${formatedFather_dob}T00:00:00`);
      }
      else {
        father_dob = null
      }

      if (this.rowInfo.family.mother_dob !== '' && this.rowInfo.family.mother_dob !== ' ' && this.rowInfo.family.mother_dob != null && this.rowInfo.family.mother_dob != undefined) {
        let formatedMother_dob = this.datePipe.transform(this.rowInfo.family.mother_dob, 'yyyy-MM-dd');
        mother_dob = new Date(`${formatedMother_dob}T00:00:00`);
      }
      else {
        mother_dob = null
      }

      if (this.rowInfo.family.spouse_dob !== '' && this.rowInfo.family.spouse_dob !== ' ' && this.rowInfo.family.spouse_dob != null && this.rowInfo.family.spouse_dob != undefined) {
        let formatedSpouse_dob = this.datePipe.transform(this.rowInfo.family.spouse_dob, 'yyyy-MM-dd');
        spouse_dob = new Date(`${formatedSpouse_dob}T00:00:00`);
      }
      else {
        spouse_dob = null
      }

      if (this.rowInfo.family.fatherinlaw_dob !== '' && this.rowInfo.family.fatherinlaw_dob !== ' ' && this.rowInfo.family.fatherinlaw_dob != null && this.rowInfo.family.fatherinlaw_dob != undefined) {
        let formatedFatherinlaw_dob = this.datePipe.transform(this.rowInfo.family.fatherinlaw_dob, 'yyyy-MM-dd');
        fatherinlaw_dob = new Date(`${formatedFatherinlaw_dob}T00:00:00`);
      }
      else {
        fatherinlaw_dob = null
      }

      if (this.rowInfo.family.motherinlaw_dob !== '' && this.rowInfo.family.motherinlaw_dob !== ' ' && this.rowInfo.family.motherinlaw_dob != null && this.rowInfo.family.motherinlaw_dob != undefined) {
        let formatedMotherinlaw_dob = this.datePipe.transform(this.rowInfo.family.motherinlaw_dob, 'yyyy-MM-dd');
        motherinlaw_dob = new Date(`${formatedMotherinlaw_dob}T00:00:00`);
      }
      else {
        motherinlaw_dob = null
      }

      this.onboardCreateForm.get('family').patchValue({
        father_name: this.rowInfo.family.father_name,
        //father_dob: this.rowInfo.family.father_dob,
        father_dob: father_dob,
        father_gender: this.rowInfo.family.father_gender,
        father_address: this.rowInfo.family.father_address,
        mother_name: this.rowInfo.family.mother_name,
        // mother_dob: this.rowInfo.family.mother_dob,
        mother_dob: mother_dob,
        mother_gender: this.rowInfo.family.mother_gender,
        mother_address: this.rowInfo.family.mother_address,
        spouse_name: this.rowInfo.family.spouse_name,
        //spouse_dob: this.rowInfo.family.spouse_dob,
        spouse_dob: spouse_dob,
        spouse_gender: this.rowInfo.family.spouse_gender,
        spouse_address: this.rowInfo.family.spouse_address,
        fatherinlaw_name: this.rowInfo.family.fatherinlaw_name,
        // fatherinlaw_dob: this.rowInfo.family.fatherinlaw_dob,
        fatherinlaw_dob: fatherinlaw_dob,
        fatherinlaw_gender: this.rowInfo.family.fatherinlaw_gender,
        fatherinlaw_address: this.rowInfo.family.fatherinlaw_address,
        motherinlaw_name: this.rowInfo.family.motherinlaw_name,
        //motherinlaw_dob: this.rowInfo.family.motherinlaw_dob,
        motherinlaw_dob: motherinlaw_dob,
        motherinlaw_gender: this.rowInfo.family.motherinlaw_gender,
        motherinlaw_address: this.rowInfo.family.motherinlaw_address,
      })
      if (this.rowInfo.family.siblings) {
        this.siblings = this.clearFormArray(this.onboardCreateForm.get('family').get('siblings') as FormArray);
        // while (this.siblings.length !== 0) { this.siblings.removeAt(0) }
        this.rowInfo.family.siblings.forEach(element => {
          if (element.dob != null && element.dob !== undefined && element.dob !== '') {
            let siblingDob = this.datePipe.transform(element.dob, 'yyyy-MM-dd');
            element.dob = new Date(`${siblingDob}T00:00:00`);
          } else {
            element.dob = null;
          }
          this.siblings.push(this.addNewSiblingsFormArrayFieldBasedOnData(element));
        });
      }
      if (this.rowInfo.family.children) {
        this.children = this.clearFormArray(this.onboardCreateForm.get('family').get('children') as FormArray);
        // while (this.children.length !== 0) { this.children.removeAt(0) }
        this.rowInfo.family.children.forEach(element => {
          if (element.dob != null && element.dob != undefined && element.dob != '') {
            let childrenDob = this.datePipe.transform(element.dob, 'yyyy-MM-dd');
            element.dob = new Date(`${childrenDob}T00:00:00`);
          } else {
            element.dob = null;
          }
          this.children.push(this.addNewChildrenFormArrayFieldBasedOnData(element));
        });
      }
    }
    if (this.rowInfo.language) {
      this.language = this.clearFormArray(this.onboardCreateForm.get('language') as FormArray);
      // while (this.language.length !== 0) { this.language.removeAt(0) }
      this.rowInfo.language.forEach(element => {
        this.language.push(this.onboardFormsUtil.addNewLanguagesFormArrayFieldBasedOnData(this.orgBasedOnboardFormsJson, element))
      });
    }
    this.loadAllDocuments();
    this.onboardCreateForm.updateValueAndValidity();
    setTimeout(() => { //delay assign this.initialFormValue for candidatedata array
      this.initialFormValue = JSON.parse(JSON.stringify(this.onboardCreateForm.value)); // Deep clone
    }, 1000);
    this.onboardCreateForm.disable();
  }

  patchCandidateData() {
    // Reference tab
    if (this.rowInfo && this.rowInfo.reference) {
      this.reference = this.clearFormArray(this.onboardCreateForm.get('reference') as FormArray);
      this.rowInfo.reference.forEach(element => {
        this.reference.push(this.onboardFormsUtil.addNewReferenceFormArrayFieldBasedOnData(element))
        this.splitPhoneNumberForFormArray('contact', 'reference', this.reference.length - 1);
      });
    } else {
      this.reference = this.clearFormArray(this.onboardCreateForm.get('reference') as FormArray);
    }
    if (this.rowInfo && this.rowInfo.family) {
      if (this.rowInfo.family.siblings) {
        this.siblings = this.clearFormArray(this.onboardCreateForm.get('family').get('siblings') as FormArray);
        this.rowInfo.family.siblings.forEach(element => {
          this.siblings.push(this.addNewSiblingsFormArrayFieldBasedOnData(element));
        });
      } else {
        this.siblings = this.clearFormArray(this.onboardCreateForm.get('family').get('siblings') as FormArray);
      }
      if (this.rowInfo.family.children) {
        this.children = this.clearFormArray(this.onboardCreateForm.get('family').get('children') as FormArray);
        this.rowInfo.family.children.forEach(element => {
          this.children.push(this.addNewChildrenFormArrayFieldBasedOnData(element));
        });
      } else {
        this.children = this.clearFormArray(this.onboardCreateForm.get('family').get('children') as FormArray);
      }
    }
    if (this.rowInfo && this.rowInfo.language) {
      this.language = this.clearFormArray(this.onboardCreateForm.get('language') as FormArray);
      this.rowInfo.language.forEach(element => {
        this.language.push(this.onboardFormsUtil.addNewLanguagesFormArrayFieldBasedOnData(this.orgBasedOnboardFormsJson, element))
      });
    } else {
      this.language = this.clearFormArray(this.onboardCreateForm.get('language') as FormArray);
    }
    if (!this.editable) {
      this.onboardCreateForm.disable();
    }
  }

  disableeditButton: boolean = false;
  enableEdit() {
    if (this.currentDisplayLanguage !== 'en') {
      let dialogRef;
      dialogRef = this.dialog.open(GoToOriginalDialog, {
      });
      dialogRef.afterClosed().subscribe(data => {
        this.editable = false;
      })
    } else {
      this.SelectedTabChange(true);
      // Checking document Collection Editable
      if (this.compensationdoceditable || this.iddoceditable || this.eduexpdoceditable || this.formsdoceditable) {
        if (this.compensationdoceditable) {
          this.cancelFileEdit('compensationdetails');
          this.compensationdoceditable = false
        }
        if (this.iddoceditable) {
          this.cancelFileEdit('idattachments');
          this.iddoceditable = false
        }
        if (this.eduexpdoceditable) {
          this.cancelFileEdit('eduexpattachments');
          this.eduexpdoceditable = false
        }
        if (this.formsdoceditable) {
          this.cancelFileEdit('forms');
          this.formsdoceditable = false
        }
      }
      // Enabling Onboard Edit
      this.editable = true;
      this.disableeditButton = true;
      this.onboardCreateForm.enable();
    }
    this.userService.isCandProfileEditActive(true);//For Hide Language Change while Canidate Edit
  }

  disableEdit() {
    this.editable = false;
    this.disableeditButton = false;
    this.onboardCreateForm.disable();
  }

  autoFillPermanentAddress() {
    if (this.sameascurrentaddresscheck == true) {
      this.onboardCreateForm.patchValue({
        permaddline1: this.onboardCreateForm.get('curaddline1').value,
        permaddline2: this.onboardCreateForm.get('curaddline2').value,
        permcity: this.onboardCreateForm.get('curtcity').value,
        permstate: this.onboardCreateForm.get('curtstate').value,
        permpin: this.onboardCreateForm.get('curpin').value,
        permcountry: this.onboardCreateForm.get('curcountry').value,
      });
    }
    this.onboardCreateForm.updateValueAndValidity();
  }

  selectedFiles: FileList;
  currentFileUpload: File;
  sameascurrentaddresscheck: boolean = false;
  showOptions(event) {
    this.sameascurrentaddresscheck = event.checked;
    if (event.checked === true) {
      this.onboardCreateForm.get('curaddline1').markAsDirty();
      this.onboardCreateForm.get('curaddline2').markAsDirty();
      this.onboardCreateForm.get('curtcity').markAsDirty();
      this.onboardCreateForm.get('curtstate').markAsDirty();
      this.onboardCreateForm.get('curpin').markAsDirty();
      this.onboardCreateForm.get('curcountry').markAsDirty();
      this.onboardCreateForm.patchValue({
        permaddline1: this.onboardCreateForm.get('curaddline1').value,
        permaddline2: this.onboardCreateForm.get('curaddline2').value,
        permcity: this.onboardCreateForm.get('curtcity').value,
        permstate: this.onboardCreateForm.get('curtstate').value,
        permpin: this.onboardCreateForm.get('curpin').value,
        permcountry: this.onboardCreateForm.get('curcountry').value,
      });
    }
    else {
      this.onboardCreateForm.patchValue({
        permaddline1: '',
        permaddline2: '',
        permcity: '',
        permstate: '',
        permpin: '',
        permcountry: '',
      });
      this.onboardCreateForm.get('curaddline1').markAsDirty();
      this.onboardCreateForm.get('curaddline2').markAsDirty();
      this.onboardCreateForm.get('curtcity').markAsDirty();
      this.onboardCreateForm.get('curtstate').markAsDirty();
      this.onboardCreateForm.get('curpin').markAsDirty();
      this.onboardCreateForm.get('curcountry').markAsDirty();
    }
    this.onboardCreateForm.updateValueAndValidity();
  }
  convertBase64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  /**validations only numbers */
  /**Key Press Decimal Value */
  keyPressdecimalonly(event: any) {
    const pattern = /[0-9.]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  public OnlyNumbers($event) {
    let regex: RegExp = new RegExp(/[0-9\ ]/);

    if (regex.test($event.key)) {
      return true;
    } else {
      return false;
    }
  }

  keyPressnumberonly(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  inputSpaceRestrict(event) {
    if (event.target.selectionStart === 0 && event.code === 'Space') { //restrict first letter is empty space
      event.preventDefault();
    }
  }

  keyPresssalutation(event: any) {
    const pattern = /[]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  keyPressalphabetonly(event: any) {
    const text = /^[a-zA-Z\\.;,:'!@#$%^&*()'?/ ]$/g;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !text.test(inputChar)) {
      event.preventDefault();
    }
  }

  textOnlyKeyPress(event) {
    var charCode = event.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || charCode == 32)
      return true;
    else
      return false;
  }

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [SEMICOLON, ENTER];
  hobbies: string[] = [
  ];
  addHobbies(event: MatChipInputEvent, key): void {
    const input = event.input;
    const value = event.value;
    let currentPanelList = this.onboardCreateForm.get('hobbies').value;
    if (currentPanelList == null || currentPanelList === '' || currentPanelList == undefined || currentPanelList.length <= 0) {
      currentPanelList = new Array<string>();
    }
    if (currentPanelList.length < 7) {
      if ((value || '').trim()) {
        if (currentPanelList.findIndex(e => e.toLowerCase() === value.trim().toLowerCase()) < 0) {
          currentPanelList.push(value.trim())
        }
      }
      if (input) {
        input.value = '';
      }
      this.onboardCreateForm.get('hobbies').setValue(currentPanelList);
      this.onboardCreateForm.get('hobbies').updateValueAndValidity();
      this.onboardCreateForm.get('hobbies').markAsDirty();

    }
    else {
      if (input) {
        input.value = '';
      }
    }
  }

  removeHobbies(val, key) {
    let currentPanelList = this.onboardCreateForm.get('hobbies').value;
    const index = currentPanelList.indexOf(val);
    if (index >= 0) {
      currentPanelList.splice(index, 1);
    }
    this.onboardCreateForm.get('hobbies').setValue(currentPanelList);
    this.onboardCreateForm.get('hobbies').markAsDirty();
    this.onboardCreateForm.get('hobbies').updateValueAndValidity();
  }

  //On window resize this method is called
  //the new innerWidth is stored to variable innerWidth
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth > 767) {
      this.innerWidth = true
    }
    else {
      this.innerWidth = false
    }
  }


  language: FormArray = <any>[];
  education: FormArray = <any>[];
  declaration: FormGroup = <any>[];
  experience: FormArray = <any>[];
  skills: FormArray = <any>[];
  reference: FormArray = <any>[];
  siblings: FormArray = <any>[];
  children: FormArray = <any>[];
  relativeworkingdetails: FormArray = <any>[];
  //initialize onboard CreateForm
  createForm() {
    this.initializeForm()
    this.onboardCreateForm.updateValueAndValidity();
    //initiating language
    this.language = this.onboardCreateForm.get('language') as FormArray;
    //initiating Education 
    // this.education = this.onboardCreateForm.get('candidatedata').get('education') as FormArray;
    // //initiating Experience 
    // this.experience = this.onboardCreateForm.get('candidatedata').get('experience') as FormArray;
    // //initiating Skill 
    // this.skills = this.onboardCreateForm.get('candidatedata').get('skills') as FormArray;
    //initiating Reference
    this.reference = this.onboardCreateForm.get('reference') as FormArray;
    this.onboardCreateForm.updateValueAndValidity();
  }

  //education 
  // additemToEducation() {
  //   this.education = this.onboardCreateForm.get('candidatedata').get('education') as FormArray;
  //   if (this.checkIfCandidateDataAddable(this.education)) {
  //     this.education.push(this.addNewEducationFormArrayField());
  //     this.education.markAsDirty();
  //   }
  // }

  // deleteEducation(i) {
  //   this.education = this.onboardCreateForm.get('candidatedata').get('education') as FormArray;
  //   if (this.education.length > 0) {
  //     if (this.education.at(i).get('id').value != null && this.education.at(i).get('id').value != '' &&
  //       this.education.at(i).get('id').value != undefined) {
  //       this.education.at(i).get('status').setValue('delete');
  //       this.education.markAsDirty();
  //     }
  //     else {
  //       this.education.removeAt(i);
  //       this.education.markAsDirty();
  //     }
  //   }
  // }

  //experience 
  // additemToExperience() {
  //   this.experience = this.onboardCreateForm.get('candidatedata').get('experience') as FormArray;
  //   if (this.checkIfCandidateDataAddable(this.experience)) {
  //     this.experience.push(this.addNewExperienceFormArrayField());
  //     this.experience.markAsDirty();
  //   }
  // }

  // deleteExperience(i) {
  //   this.experience = this.onboardCreateForm.get('candidatedata').get('experience') as FormArray;
  //   if (this.experience.length > 0) {
  //     if (this.experience.at(i).get('id').value != null && this.experience.at(i).get('id').value != '' &&
  //       this.experience.at(i).get('id').value != undefined) {
  //       this.experience.at(i).get('status').setValue('delete');
  //       this.experience.markAsDirty();
  //     }
  //     else {
  //       this.experience.removeAt(i);
  //       this.experience.markAsDirty();
  //     }
  //   }
  //   this.onboardCreateForm.updateValueAndValidity();
  // }

  checkIfCandidateDataAddable(data: FormArray) {
    let currentarray = data.controls.filter(x => x.get('status').value != 'delete');
    if (currentarray.length < 5) {
      return true;
    }
    else {
      return false;
    }
  }

  //Language 
  additemToLanguage() {
    this.language = this.onboardCreateForm.get('language') as FormArray;
    if (this.language.length < 5) {
      this.language.push(this.addNewLanguagesFormArrayField());
      this.language.markAsUntouched();
      this.language.markAsDirty();
    }
  }

  deleteLanguage(i) {
    this.language = this.onboardCreateForm.get('language') as FormArray;
    if (this.language.length > 1) {
      this.language.removeAt(i);
      this.language.markAsDirty();
    }
  }

  addFieldValueReference() {
    this.reference = this.onboardCreateForm.get('reference') as FormArray;
    if (this.reference.length < 5) {
      this.reference.push(this.addNewReferenceFormArrayField(this.OrganizationPreloadsInfo.defaultcountrycode));
      this.reference.markAsDirty();
    }
  }

  deleteFieldValueReference(index) {
    this.reference = this.onboardCreateForm.get('reference') as FormArray;
    this.reference.removeAt(index);
    this.reference.markAsDirty();
  }

  additemToSibling() {
    this.siblings = this.onboardCreateForm.get('family').get('siblings') as FormArray;
    if (this.siblings.length < 5) {
      this.siblings.push(this.addNewSiblingsFormArrayField());
      this.siblings.markAsDirty();
    }
  }

  deleteSibling(i) {
    this.siblings = this.onboardCreateForm.get('family').get('siblings') as FormArray;
    this.siblings.removeAt(i);
    this.siblings.markAsDirty();
  }

  additemToChildren() {
    this.children = this.onboardCreateForm.get('family').get('children') as FormArray;
    if (this.children.length < 5) {
      this.children.push(this.addNewChildrenFormArrayField());
      this.children.markAsDirty();
    }
  }

  deleteChildren(i) {
    this.children = this.onboardCreateForm.get('family').get('children') as FormArray;
    this.children.removeAt(i);
    this.children.markAsDirty();
  }

  // additemToRelativeWorking() {
  //   this.relativeworkingdetails = this.onboardCreateForm.get('declaration').get('relativeworkingdetails') as FormArray;
  //   if (this.relativeworkingdetails.length < 5) {
  //     this.relativeworkingdetails.push(this.addNewRelativeFormArrayField());
  //   }
  //   this.relativeworkingdetails.markAsDirty();
  // }

  deleteRelative(i) {
    this.relativeworkingdetails = this.onboardCreateForm.get('declaration').get('relativeworkingdetails') as FormArray;
    this.relativeworkingdetails.removeAt(i);
    this.relativeworkingdetails.markAsDirty();
  }


  formatDate(date: Date | string) {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }


  convertDatesBeforeSaveUpdateEdit() {
    const family = this.onboardCreateForm.get('family');
    // Convert father_dob
    if (family.get('father_dob').value) {
      family.get('father_dob').setValue(this.formatDate(family.get('father_dob').value));
    } else {
      family.get('father_dob').setValue(null);
    }

    // Convert spouse_dob
    if (family.get('spouse_dob').value) {
      family.get('spouse_dob').setValue(this.formatDate(family.get('spouse_dob').value));
    } else {
      family.get('spouse_dob').setValue(null);
    }

    // Convert mother_dob
    if (family.get('mother_dob').value) {
      family.get('mother_dob').setValue(this.formatDate(family.get('mother_dob').value));
    } else {
      family.get('mother_dob').setValue(null);
    }

    // Convert fatherinlaw_dob
    if (family.get('fatherinlaw_dob').value) {
      family.get('fatherinlaw_dob').setValue(this.formatDate(family.get('fatherinlaw_dob').value));
    } else {
      family.get('fatherinlaw_dob').setValue(null);
    }

    // Convert motherinlaw_dob
    if (family.get('motherinlaw_dob').value) {
      family.get('motherinlaw_dob').setValue(this.formatDate(family.get('motherinlaw_dob').value));
    } else {
      family.get('motherinlaw_dob').setValue(null);
    }

    // Process siblings array
    this.siblings = this.onboardCreateForm.get('family').get('siblings') as FormArray;
    this.siblings.controls.forEach((siblingFormGroup: FormGroup) => {
      if (siblingFormGroup.get('dob').value) {
        siblingFormGroup.get('dob').setValue(this.formatDate(siblingFormGroup.get('dob').value));
      } else {
        siblingFormGroup.get('dob').setValue(this.formatDate(null));
      }
    })


    // Process children array
    this.children = this.onboardCreateForm.get('family').get('children') as FormArray;
    this.children.controls.forEach((childrenFormGroup: FormGroup) => {
      if (childrenFormGroup.get('dob').value) {
        childrenFormGroup.get('dob').setValue(this.formatDate(childrenFormGroup.get('dob').value));
      } else {
        childrenFormGroup.get('dob').setValue(null);
      }
    });

  }

  submit() {
    if (this.onboardCreateForm.valid) {
      /**Get Id & Status from candidate input */
      if (this.rowInfo) {
        this.onboardCreateForm.controls['id'].setValue(this.loggedInCandidateId);
        this.onboardCreateForm.controls['status'].setValue(this.rowInfo.candidatestatus);
        if (this.rowInfo.created_by != null && this.rowInfo.created_by != undefined && this.rowInfo.created_by != '') {
          this.onboardCreateForm.controls['modified_by'].setValue(this.loggedInOrgID);
          this.onboardCreateForm.controls['modified_on'].setValue(new Date());
        }
        else {
          this.onboardCreateForm.controls['created_by'].setValue(this.loggedInOrgID);
          this.onboardCreateForm.controls['createdon'].setValue(new Date());
        }
      }
      this.onboardCreateForm.controls['id'].setValue(this.loggedInCandidateId);
      this.onboardCreateForm.controls['orgid'].setValue(this.loggedInOrgID);
      this.convertDatesBeforeSaveUpdateEdit();
      this.isLoaderEnabled = true;

      this.onboardService.submitOnboard(this.onboardCreateForm.value).subscribe(
        response => {
          this.editable = false;
          this.SelectedTabChange(false);
          this.localStorageUtil.clearSessionStorageExceptExclusionKey();
          this.rowInfo = {
            ...this.rowInfo, ...response
          }
          this.rowInfoMasterData = JSON.parse(JSON.stringify(this.rowInfo));
          this.patchInfoForViewMode();
          this.isLoaderEnabled = false;
          this.onboardCreateForm.markAsPristine();
          this.onboardCreateForm.disable();
          this.snackBarUtil.triggerSnackBar(SnackbarConstants.DATA_UPDATED_MESSAGE)

          this.updatedRowInfoTrigger(this.rowInfo);
        },
        error => {
          this.isLoaderEnabled = false;
        });
      this.showErrorFields = false;
      this.isLoaderEnabled = true;
    }
    else {
      this.checkIfFormGroupIsValid();
      this.onboardCreateForm.markAllAsTouched();
      this.snackBarUtil.triggerSnackBar(SnackbarConstants.RESOLVE_ISSUES_MESSAGE)
      this.showErrorFields = true;
    }
    this.userService.isCandProfileEditActive(false);//For Hide Language Change while Canidate Edit
  }

  cancelOnboardEdit() {
    this.editable = false;
    this.SelectedTabChange(false);
    this.patchInfoForViewMode();
    this.patchCandidateData();
    this.onboardCreateForm.disable();
    this.onboardCreateForm.markAsPristine();
    this.showErrorFields = false;
    this.localStorageUtil.clearSessionStorageExceptExclusionKey();
    this.userService.isCandProfileEditActive(false);//For Hide Language Change while Canidate Edit
  }

  getDirtyValues(form: any) {
    let dirtyValues = {};

    Object.keys(form.controls)
      .forEach(key => {
        const currentControl = form.controls[key];

        if (currentControl.dirty) {
          if (currentControl.controls)
            dirtyValues[key] = this.getDirtyValues(currentControl);
          else
            dirtyValues[key] = currentControl.value;
        }
      });

    return dirtyValues;
  }

  reset() {
    this.onboardCreateForm.reset();
    this.onboardCreateForm.clearValidators();
  }

  appendPhoneNumber(dialcode, mobile, field) {
    if (field != 'supervisor_mobino') {
      var mobileno = "";
      if (this.onboardCreateForm.get(dialcode).value && this.onboardCreateForm.get(dialcode).value !== '' && this.onboardCreateForm.get(dialcode).value !== 'null') {
        mobileno = this.onboardCreateForm.get(dialcode).value + " ";
      }
      if (this.onboardCreateForm.get(mobile).value && this.onboardCreateForm.get(mobile).value !== '' && this.onboardCreateForm.get(mobile).value !== 'null') {
        mobileno = mobileno + this.onboardCreateForm.get(mobile).value;
      }
      this.onboardCreateForm.get(field).setValue(mobileno);
    }
    else {
      var mobileno = "";
      if (this.onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_dialcode').value && this.onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_dialcode').value !== '' && this.onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_dialcode').value !== 'null') {
        mobileno = this.onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_dialcode').value + " ";
      }
      if (this.onboardCreateForm.controls.declaration.get('workedpreviouslydetails').get('supervisor_mobilenumber').value && this.onboardCreateForm.controls.declaration.get('workedpreviouslydetails').get('supervisor_mobilenumber').value !== '' && this.onboardCreateForm.controls.declaration.get('workedpreviouslydetails').get('supervisor_mobilenumber').value !== 'null') {
        mobileno = mobileno + this.onboardCreateForm.controls.declaration.get('workedpreviouslydetails').get('supervisor_mobilenumber').value;
      }
      this.onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_mobino').setValue(mobileno);
    }
  }

  appendPhoneNumberForFormArray(dialcode, mobile, field, formarrayfield, index) {
    let formArray: FormArray;
    if (formarrayfield == 'relativeworkingdetails') {
      formArray = this.onboardCreateForm.get('declaration').get(formarrayfield) as FormArray;
    }
    else {
      formArray = this.onboardCreateForm.get(formarrayfield) as FormArray;
    }
    var mobileno = formArray.at(index).get(dialcode).value + ' ' + formArray.at(index).get(mobile).value
    this.countryCode = formArray.at(index).get(dialcode).value;
    formArray.at(index).get(field).setValue(mobileno);
    formArray.at(index).get(field).updateValueAndValidity();

  }

  splitPhoneNumberForFormArray(field, formarrayfield, index) {
    let formArray: FormArray;

    if (formarrayfield == 'relativeworkingdetails') {
      formArray = this.onboardCreateForm.get('declaration').get(formarrayfield) as FormArray;
    }
    else {
      formArray = this.onboardCreateForm.get(formarrayfield) as FormArray;
    }

    if (formArray.at(index).get(field).value && formArray.at(index).get(field).value.toString().includes('+')) {
      var array = formArray.at(index).get(field).value.toString().split(' ');
      formArray.at(index).get('dialcode').setValue(array[0]);
      formArray.at(index).get('mobilenumber').setValue(array[1]);
    }
  }

  // Documents Related 
  educationproof: FormArray = <any>[];
  experienceproof: FormArray = <any>[];
  compensationdoceditable: boolean = false;
  iddoceditable: boolean = false;
  formsdoceditable: boolean = false;
  eduexpdoceditable: boolean = false;
  preloadedFilesMasterJSON: any;
  educationfilenamesMasterList: Array<string>;
  experiencefilenamesMasterList: Array<string>;
  isdocumentsloaded: boolean = false;
  isorgdocsloaded: boolean = false;
  documentCollectionMasterInfo: any;
  isRecruitmentManager: boolean = false;

  loadAllDocuments() {
    if (!this.isdocumentsloaded) {
      this.onboardService.checkIfFilesUploadedorNot(this.rowInfo.id, this.loggedInOrgID, this.rowInfo.uploadedfiles, 'Onboard', this.loggedInUsername, this.rowInfo.reqid, this.isRecruitmentManager).subscribe((fileresponse: any) => {
        if (fileresponse) {
          this.rowInfo.candidatedata = fileresponse.candidatedata;
          this.rowInfoMasterData = JSON.parse(JSON.stringify(this.rowInfo));
          this.patchCandidateData();
          this.documentCollectionMasterInfo = JSON.parse(JSON.stringify(fileresponse));
          this.isdocumentsloaded = true;
          this.patchDocumentCollectionForm(fileresponse);
        }
      })
    }
  }

  // inside
  downloadAllFilesAsZip() {
    if (this.currentDisplayLanguage !== 'en') {
      let dialogRef;
      dialogRef = this.dialog.open(GoToOriginalDialog, {
        // height: "210px"
      });
    } else {
      this.bulkSelectedItems = [];
      if (!this.isorgdocsloaded) {
        if (this.preonboardfilesuploaded && this.preonboardfilesuploaded.length > 0) {

          this.preonboardfilesuploaded.forEach((data) => {
            this.bulkSelectedItems.push({
              username: this.loggedInUsername,
              filename: data,
              orgid: this.loggedInOrgID,
              id: this.rowInfo.id,
              module: 'Candidate',
              bulkdownloadfilename: 'My Documents'
            });
          })
          this.isLoaderEnabled = true;
          this.onboardService.onboardboardFileDownload(this.bulkSelectedItems).subscribe((data: any) => {
            this.isLoaderEnabled = false;
            this.snackBarUtil.triggerSnackBar(SnackbarConstants.REQUEST_HAS_TAKEN_MESSAGE)
          },
            error => {
              this.isLoaderEnabled = false
              this.snackBarUtil.triggerSnackBar(SnackbarConstants.ERROR_MESSAGE)
            })
        }
      }
      else {
        this.snackBarUtil.triggerSnackBar(SnackbarConstants.REQUEST_HAS_TAKEN_ALREADY_MESSAGE)
      }
    }
  }

  downloadOrgbasedPreonboardDocs() {
    if (this.currentDisplayLanguage !== 'en') {
      let dialogRef;
      dialogRef = this.dialog.open(GoToOriginalDialog, {
        // height: "210px"
      });
    } else {
      this.bulkSelectedItems = [];
      if (!this.isorgdocsloaded) {
        if (this.preonboardfilesuploaded && this.preonboardfilesuploaded.length > 0) {

          this.preonboardfilesuploaded.forEach((data) => {
            this.bulkSelectedItems.push({
              username: this.loggedInUsername,
              filename: data,
              orgid: this.loggedInOrgID,
              id: this.rowInfo.id,
              module: 'Candidate',
              bulkdownloadfilename: 'My Documents'
            });
          })
          this.isLoaderEnabled = true;
          this.onboardService.onboardboardFileDownload(this.bulkSelectedItems).subscribe((data: any) => {
            this.isLoaderEnabled = false;
            this.snackBarUtil.triggerSnackBar(SnackbarConstants.REQUEST_HAS_TAKEN_MESSAGE)
          },
            error => {
              this.isLoaderEnabled = false
              this.snackBarUtil.triggerSnackBar(SnackbarConstants.ERROR_MESSAGE)
            })
        }
      }
      else {
        this.snackBarUtil.triggerSnackBar(SnackbarConstants.REQUEST_HAS_TAKEN_ALREADY_MESSAGE)
      }
    }
  }

  downloadOrgbasedZipFiles() {
    let data = {
      downloadtype: "bulkdownload",
      orgid: this.loggedInOrgID,
      username: this.loggedInUserName,
    }
    this.isLoaderEnabled = true;
    this.onboardService.onboardboardZipFileDownload(data).subscribe((data: any) => {
      this.isLoaderEnabled = false;
      this.snackBarUtil.triggerSnackBar(SnackbarConstants.REQUEST_TAKEN_CHECK_MESSAGE)
    },
      error => {
        this.isLoaderEnabled = false
        this.snackBarUtil.triggerSnackBar(SnackbarConstants.ERROR_MESSAGE)
      })
  }

  // inside
  bulkSelectedItems = [];
  // downloadAllFilesAsZip() {
  //   this.bulkSelectedItems = [];
  //   this.isLoaderEnabled = true;
  // }

  patchDocumentCollectionForm(fileresponse) {
    if (fileresponse?.compensationDetailsOnboard) {
      if (fileresponse.compensationDetailsOnboard.bankstatementUploaded || fileresponse.compensationDetailsOnboard.bankstatementUploaded === 'true') {
        this.onboardCreateForm.get('compensationdetails').get('bankstatement').setValue(true)
        this.onboardCreateForm.get('compensationdetails').get('bankstatement').updateValueAndValidity();
      }
      if (fileresponse.compensationDetailsOnboard.bonuspayoutformUploaded || fileresponse.compensationDetailsOnboard.bonuspayoutformUploaded === 'true') {
        this.onboardCreateForm.get('compensationdetails').get('bonuspayoutform').setValue(true)
        this.onboardCreateForm.get('compensationdetails').get('bonuspayoutform').updateValueAndValidity();
      }
      if (fileresponse.compensationDetailsOnboard.latestsalarybreakupUploaded || fileresponse.compensationDetailsOnboard.latestsalarybreakupUploaded === 'true') {
        this.onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').setValue(true);
        this.onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').updateValueAndValidity();
      }
      if (fileresponse.compensationDetailsOnboard.payslip1Uploaded || fileresponse.compensationDetailsOnboard.payslip1Uploaded === 'true') {
        this.onboardCreateForm.get('compensationdetails').get('payslip1').setValue(true)
      }
      if (fileresponse.compensationDetailsOnboard.payslip2Uploaded || fileresponse.compensationDetailsOnboard.payslip2Uploaded === 'true') {
        this.onboardCreateForm.get('compensationdetails').get('payslip2').setValue(true)
      }
      if (fileresponse.compensationDetailsOnboard.payslip3Uploaded || fileresponse.compensationDetailsOnboard.payslip3Uploaded === 'true') {
        this.onboardCreateForm.get('compensationdetails').get('payslip3').setValue(true)
      }
    }
    if (fileresponse?.formsOnboard) {
      if (fileresponse.formsOnboard.employmentapplicationformUploaded || fileresponse.formsOnboard.employmentapplicationformUploaded === 'true') {
        this.onboardCreateForm.get('forms').get('employmentapplicationform').setValue(true)
      }
      if (fileresponse.formsOnboard.bgvformUploaded || fileresponse.formsOnboard.bgvformUploaded === 'true') {
        this.onboardCreateForm.get('forms').get('bgvform').setValue(true)
      }
      if (fileresponse.formsOnboard.joiningformUploaded || fileresponse.formsOnboard.joiningformUploaded === 'true') {
        this.onboardCreateForm.get('forms').get('joiningform').setValue(true)
      }
      if (fileresponse.formsOnboard.pfuanUploaded || fileresponse.formsOnboard.pfuanUploaded === 'true') {
        this.onboardCreateForm.get('forms').get('pfuan').setValue(true)
      }
      if (fileresponse.formsOnboard.medicalreportUploaded || fileresponse.formsOnboard.medicalreportUploaded === 'true') {
        this.onboardCreateForm.get('forms').get('medicalreport').setValue(true)
      }
      if (fileresponse.formsOnboard.conflictofinterestformUploaded || fileresponse.formsOnboard.conflictofinterestformUploaded === 'true') {
        this.onboardCreateForm.get('forms').get('conflictofinterestform').setValue(true)
      }
      if (fileresponse.formsOnboard.confidentialityformUploaded || fileresponse.formsOnboard.confidentialityformUploaded === 'true') {
        this.onboardCreateForm.get('forms').get('confidentialityform').setValue(true)
      }
    }
    if (fileresponse?.idAttachmentsOnboard) {
      if (fileresponse.idAttachmentsOnboard.pancardUploaded || fileresponse.idAttachmentsOnboard.pancardUploaded === 'true') {
        this.onboardCreateForm.get('idattachments').get('pancard').setValue(true)
      }
      if (fileresponse.idAttachmentsOnboard.passportUploaded || fileresponse.idAttachmentsOnboard.passportUploaded === 'true') {
        this.onboardCreateForm.get('idattachments').get('passport').setValue(true)
      }
      if (fileresponse.idAttachmentsOnboard.photographUploaded || fileresponse.idAttachmentsOnboard.photographUploaded === 'true') {
        this.onboardCreateForm.get('idattachments').get('photograph').setValue(true)
      }
      if (fileresponse.idAttachmentsOnboard.ssnUploaded || fileresponse.idAttachmentsOnboard.ssnUploaded === 'true') {
        this.onboardCreateForm.get('idattachments').get('ssn').setValue(true)
      }
    }
    //getting edu exp file names
    this.educationfilenamesMasterList = new Array<string>();
    this.experiencefilenamesMasterList = new Array<string>();
    if (fileresponse?.eduExpAttachmentsOnboard) {
      // page load scenario 
      if (fileresponse.eduExpAttachmentsOnboard.educationfilenames && fileresponse.eduExpAttachmentsOnboard.educationfilenames.length > 0) {
        fileresponse.eduExpAttachmentsOnboard.educationfilenames.forEach(element => {
          let splitarray = element.split('_')
          this.educationfilenamesMasterList.push(splitarray[1]);
          //   let splitarray = element.split('_');
          //   if (splitarray.length > 1) {
          //     // Exclude the 0th index and push the remaining parts to the list
          //     this.educationfilenamesMasterList?.push(splitarray?.slice(1)?.join('_')?.split('.')[0]?.splitarray?.slice(n-1)?.join(''));
          //   }
          //   console.log(this.educationfilenamesMasterList,"educationfilenamesMasterList");
        });
      }
      // Page update After Edit Scenario 
      if (fileresponse.eduExpAttachmentsOnboard.educationproof && fileresponse.eduExpAttachmentsOnboard.educationproof.length > 0) {
        fileresponse.eduExpAttachmentsOnboard.educationproof.forEach(element => {
          if (element.filecontent !== 'delete') {
            this.educationfilenamesMasterList.push(element.filename);
          }
        });
      }

      // page load scenario 
      if (fileresponse.eduExpAttachmentsOnboard.experiencefilenames && fileresponse.eduExpAttachmentsOnboard.experiencefilenames.length > 0) {
        fileresponse.eduExpAttachmentsOnboard.experiencefilenames.forEach(element => {
          let splitarray = element.split('_')
          this.experiencefilenamesMasterList.push(splitarray[1]);
        });
      }
      // Page update After Edit Scenario 
      if (fileresponse.eduExpAttachmentsOnboard.experienceproof && fileresponse.eduExpAttachmentsOnboard.experienceproof.length > 0) {
        fileresponse.eduExpAttachmentsOnboard.experienceproof.forEach(element => {
          if (element.filecontent !== 'delete') {
            this.experiencefilenamesMasterList.push(element.filename);
          }
        });
      }
    }
    // generating edu exp formcontrol
    this.experienceproof = this.onboardCreateForm.get('eduexpattachments').get('experienceproof') as FormArray;
    this.educationproof = this.onboardCreateForm.get('eduexpattachments').get('educationproof') as FormArray;
    // clearing Form Array
    this.experienceproof = this.clearFormArray(this.onboardCreateForm.get('eduexpattachments').get('experienceproof') as FormArray);
    this.educationproof = this.clearFormArray(this.onboardCreateForm.get('eduexpattachments').get('educationproof') as FormArray);
    this.educationfilenamesMasterList?.forEach(element => {
      this.educationproof.push(this.addNewEducationAttachmentBasedonData({ filename: element, filecontent: true }));
    });
    this.experiencefilenamesMasterList?.forEach(element => {
      this.experienceproof.push(this.addNewExperienceAttachmentBasedOnData({ filename: element, filecontent: true }));
    });
    this.onboardCreateForm.updateValueAndValidity();
  }

  triggerUniqueNameValidator(module) {
    if (module === 'experience') {
      this.experienceproof = this.onboardCreateForm.get('eduexpattachments').get('experienceproof') as FormArray;
      // Iterate over the 'educationproof' FormArray and trigger validation for each 'name' field
      for (let i = 0; i < this.experienceproof.controls.length; i++) {
        const nameControl = this.experienceproof.at(i).get('filename');
        if (nameControl) {
          nameControl.updateValueAndValidity(); // Trigger validation for 'name' field 
        }
      }

    }
    else if (module === 'education') {
      this.educationproof = this.onboardCreateForm.get('eduexpattachments').get('educationproof') as FormArray;
      // Iterate over the 'educationproof' FormArray and trigger validation for each 'name' field
      for (let i = 0; i < this.educationproof.controls.length; i++) {
        const nameControl = this.educationproof.at(i).get('filename');
        if (nameControl) {
          nameControl.updateValueAndValidity(); // Trigger validation for 'name' field
        }
      }
    }
  }

  //education 
  addNewEducationAttachment() {
    return this.formBuilder.group({
      filename: new FormControl('', [Validators.required, uniqueNameInFormArrayValidator()]),
      filecontent: new FormControl('', Validators.required),
    });
  }

  addNewEducationAttachmentBasedonData(data) {
    return this.formBuilder.group({
      filename: new FormControl(data.filename, [Validators.required, uniqueNameInFormArrayValidator()]),
      filecontent: new FormControl(data.filecontent, Validators.required),
    });
  }

  additemToAttachmentEducation() {
    this.educationproof = this.onboardCreateForm.get('eduexpattachments').get('educationproof') as FormArray;
    let currentarray: any[] = JSON.parse(JSON.stringify(this.educationproof.value));

    let activearray: any[] = currentarray.filter(e => e.filecontent.toString().toLowerCase() !== 'delete');
    if (activearray.length < 5) {
      this.educationproof.push(this.addNewEducationAttachment());
    }
  }

  deleteAttachmentEducation(i) {
    this.educationproof = this.onboardCreateForm.get('eduexpattachments').get('educationproof') as FormArray;
    if (this.educationproof.at(i).get('filecontent').value == true) {
      this.educationproof.at(i).get('filecontent').setValue('delete');
      this.educationproof.at(i).get('filecontent').markAsDirty();
      this.educationproof.at(i).get('filecontent').updateValueAndValidity();
      if (this.educationproof.at(i).get('filecontent').value == "delete") {
        this.educationproof.removeAt(i)
      }
    }
    else {
      this.educationproof.removeAt(i)
    }
  }

  //experience
  addNewExperienceAttachment() {
    return this.formBuilder.group({
      filename: new FormControl('', [Validators.required, uniqueNameInFormArrayValidator()]),
      filecontent: new FormControl('', Validators.required),
    });
  }

  addNewExperienceAttachmentBasedOnData(data) {
    return this.formBuilder.group({
      filename: new FormControl(data.filename, [Validators.required, uniqueNameInFormArrayValidator()]),
      filecontent: new FormControl(data.filecontent, Validators.required),
    });
  }

  additemToAttachmentExperience() {
    this.experienceproof = this.onboardCreateForm.get('eduexpattachments').get('experienceproof') as FormArray;
    let currentarray: any[] = JSON.parse(JSON.stringify(this.experienceproof.value));
    let activearray: any[] = currentarray.filter(e => e.filecontent.toString().toLowerCase() !== 'delete');
    if (activearray.length < 5) {
      this.experienceproof.push(this.addNewExperienceAttachment());
    }
  }

  deleteAttachmentExperience(i) {
    this.experienceproof = this.onboardCreateForm.get('eduexpattachments').get('experienceproof') as FormArray;
    if (this.experienceproof.at(i).get('filecontent').value == true) {
      this.experienceproof.at(i).get('filecontent').setValue('delete');
      this.experienceproof.at(i).get('filecontent').markAsDirty();
      this.experienceproof.at(i).get('filecontent').updateValueAndValidity();
      if (this.experienceproof.at(i).get('filecontent').value == "delete") {
        this.experienceproof.removeAt(i)
      }
    }
    else {
      this.experienceproof.removeAt(i)
    }
  }

  async fileUpload(event, formgroup, formcontrol) {
    let filesrc;
    // if (formgroup === 'idattachments') {
    filesrc = await this.fileUploadUtil.uploadFileMultipart(event, this.loggedInOrgID,formcontrol);
    if (filesrc) {
      let templloc = formcontrol + "temploc";
      let multipart = formcontrol + "multipart";
      this.onboardCreateForm.get(formgroup).get(formcontrol).setValue(filesrc.bytes);
      this.onboardCreateForm.get(formgroup).get(formcontrol).markAsDirty();
      if (filesrc.hasOwnProperty('templocation') && filesrc.templocation != null && filesrc.templocation != undefined) {
        this.onboardCreateForm.get(formgroup).get(templloc).setValue(filesrc.templocation);
      }
      else if (filesrc.hasOwnProperty('multipart') && filesrc.multipart != null && filesrc.multipart != undefined) {
        this.onboardCreateForm.get(formgroup).get(multipart).setValue(filesrc.multipart);
      }
      this.onboardCreateForm.get(formgroup).get(formcontrol).updateValueAndValidity();
    }

  }


  async fileUploadExperience(event, formarrayIndex) {
    // let files = event.target.files;
    let filesrc;
    filesrc = await this.fileUploadUtil.uploadFileMultipart(event, this.loggedInOrgID);
    if (filesrc) {
      this.experienceproof = this.onboardCreateForm.get('eduexpattachments').get('experienceproof') as FormArray;
      this.experienceproof.at(formarrayIndex).get('filecontent').setValue(filesrc.bytes);
      // this.experienceproof.at(formarrayIndex).get('filename').setValue(filesrc.multipart.name.split('.')[0]);
      this.experienceproof.at(formarrayIndex).get('filecontent').updateValueAndValidity();
    }
    // }
  }

  async fileUploadEducation(event, formarrayIndex) {
    let filesrc = await this.fileUploadUtil.uploadFileMultipart(event, this.loggedInOrgID);
    if (filesrc) {
      this.educationproof = this.onboardCreateForm.get('eduexpattachments').get('educationproof') as FormArray;
      this.educationproof.at(formarrayIndex).get('filecontent').setValue(filesrc.bytes);
      // this.educationproof.at(formarrayIndex).get('filename').setValue(filesrc.multipart.name.split('.')[0]);
      this.educationproof.at(formarrayIndex).get('filecontent').markAsDirty();
      this.educationproof.at(formarrayIndex).get('filecontent').updateValueAndValidity();
    }
    // }
  }

  fileUploadPhoto(event, formgroup, formcontrol) {
    if (this.fileUploadUtil.isImageValid(event, this.innerWidth,formcontrol)) {
      let files = event.target.files[0];
      this.onboardCreateForm.get(formgroup).get(formcontrol).setValue(files);
      this.onboardCreateForm.get(formgroup).get(formcontrol).markAsDirty();
      this.onboardCreateForm.get(formgroup).get(formcontrol).updateValueAndValidity();
    }
  }

  deleteDocumentFile(formgroup, formcontrol) {
    this.onboardCreateForm.get(formgroup).get(formcontrol).setValue('delete');
    this.onboardCreateForm.get(formgroup).get(formcontrol).markAsDirty();
    this.onboardCreateForm.get(formgroup).get(formcontrol).updateValueAndValidity();
  }

  enableFileEdit(formgroupname) {
    if (this.currentDisplayLanguage !== 'en') {
      let dialogRef;
      dialogRef = this.dialog.open(GoToOriginalDialog, {
        // height: "210px"
      });
      dialogRef.afterClosed().subscribe(data => {
        this.compensationdoceditable = false;
        this.iddoceditable = false;
        this.eduexpdoceditable = false;
        this.eduexpdoceditable = false;
        this.formsdoceditable = false;

      })
    } else {
      this.SelectedTabChange(true);
      this.onboardCreateForm.get(formgroupname).enable();
    }
    this.userService.isCandProfileEditActive(true);//For Hide Language Change while Canidate Edit

  }

  cancelFileEdit(formgroupname) {
    this.onboardCreateForm.get(formgroupname).enable();
    this.onboardCreateForm.get(formgroupname).reset();
    this.patchDocumentCollectionForm(this.documentCollectionMasterInfo);
    this.SelectedTabChange(false);
    this.userService.isCandProfileEditActive(false);//For Hide Language Change while Canidate Edit
  }

  clearFormArray(formArray: FormArray) {
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
    return formArray;
  }

  submitCompensationAccordion() {
    this.isLoaderEnabled = true;
    /**Get Id & Status from candidate input */
    if (this.rowInfo) {
      this.onboardCreateForm.controls['id'].setValue(this.rowInfo.id);
      this.onboardCreateForm.controls['status'].setValue(this.rowInfo.candidatestatus);
      if (this.rowInfo.created_by != null && this.rowInfo.created_by != undefined && this.rowInfo.created_by != '') {
        this.onboardCreateForm.controls['modified_by'].setValue(this.loggedInOrgID);
        this.onboardCreateForm.controls['modified_on'].setValue(new Date());
      }
      else {
        this.onboardCreateForm.controls['created_by'].setValue(this.loggedInOrgID);
        this.onboardCreateForm.controls['createdon'].setValue(new Date());
      }
    }
    let compensationdetailsfiles =
    {
      latestsalarybreakupBytes: this.onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value,
      bonuspayoutformBytes: this.onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value,
      bankstatementBytes: this.onboardCreateForm.get('compensationdetails').get('bankstatement').value,
      payslip1Bytes: this.onboardCreateForm.get('compensationdetails').get('payslip1').value,
      payslip2Bytes: this.onboardCreateForm.get('compensationdetails').get('payslip2').value,
      payslip3Bytes: this.onboardCreateForm.get('compensationdetails').get('payslip3').value,
    }

    let formsfiles = {}

    let idattachments = {}

    let onboardFiles =
    {
      candiateid: this.rowInfo.id,
      orgid: this.loggedInOrgID,
      filesuploaded: this.rowInfo.uploadedfiles ? this.rowInfo.uploadedfiles : [],
      compensationDetailsOnboard: compensationdetailsfiles,
      formsOnboard: formsfiles,
      idAttachmentsOnboard: idattachments
    }

    this.onboardService.uploadCompensationfiles(onboardFiles).subscribe(
      (response: any) => {
        this.isLoaderEnabled = false;
        this.rowInfo.uploadedfiles = response.filesuploaded;  // this is for set file uploaded key to rowinfo
        this.preonboardfilesuploaded = response.filesuploaded;  // this is for set file uploaded key to preonboardfilesuploaded
        this.documentCollectionMasterInfo['compensationDetailsOnboard'] = JSON.parse(JSON.stringify(response.compensationDetailsOnboard));
        this.compensationdoceditable = false;
        this.SelectedTabChange(false);
        this.patchDocumentCollectionForm(this.documentCollectionMasterInfo);
        this.snackBarUtil.triggerSnackBar(SnackbarConstants.FILES_UPLOADED_MESSAGE)
        this.onboardCreateForm.get('compensationdetails').markAsPristine();
      },
      error => {
        this.isLoaderEnabled = false;
        this.snackBarUtil.triggerSnackBar(SnackbarConstants.ERROR_MESSAGE)
      });
    this.userService.isCandProfileEditActive(false);//For Hide Language Change while Canidate Edit
  }

  submitIDAccordion() {
    this.isLoaderEnabled = true;
    /**Get Id & Status from candidate input */
    if (this.rowInfo) {
      this.onboardCreateForm.controls['id'].setValue(this.rowInfo.id);
      this.onboardCreateForm.controls['status'].setValue(this.rowInfo.candidatestatus);
      if (this.rowInfo.created_by != null && this.rowInfo.created_by != undefined && this.rowInfo.created_by != '') {
        this.onboardCreateForm.controls['modified_by'].setValue(this.loggedInOrgID);
        this.onboardCreateForm.controls['modified_on'].setValue(new Date());
      }
      else {
        this.onboardCreateForm.controls['created_by'].setValue(this.loggedInOrgID);
        this.onboardCreateForm.controls['createdon'].setValue(new Date());
      }
    }
    let compensationdetailsfiles = {}
    let formsfiles = {}
    let idattachments;
    idattachments =
    {
      photographBytes: null,
      pancardBytes: this.onboardCreateForm.get('idattachments').get('pancard').value,
      ssnBytes: this.onboardCreateForm.get('idattachments').get('ssn').value,
      passportBytes: this.onboardCreateForm.get('idattachments').get('passport').value,
      pancardMultipart: this.onboardCreateForm.get('idattachments').get('pancardmultipart').value,
      ssnMultipart: this.onboardCreateForm.get('idattachments').get('ssnmultipart').value,
      passportMultipart: this.onboardCreateForm.get('idattachments').get('passportmultipart').value,
      pancardTemploc: this.onboardCreateForm.get('idattachments').get('pancardtemploc').value,
      ssnTemploc: this.onboardCreateForm.get('idattachments').get('ssntemploc').value,
      passportTemploc: this.onboardCreateForm.get('idattachments').get('passporttemploc').value,
    }
    let onboardFiles =
    {
      candiateid: this.loggedInCandidateId,
      orgid: this.loggedInOrgID,
      filesuploaded: this.rowInfo.uploadedfiles,
      compensationDetailsOnboard: compensationdetailsfiles,
      formsOnboard: formsfiles,
      idAttachmentsOnboard: idattachments
    }
    this.onboardService.uploadidentityFiles(onboardFiles, this.onboardCreateForm.get('idattachments').get('photograph').value).subscribe(
      (response: any) => {
        if (response) {
          this.rowInfo.uploadedfiles = response?.filesuploaded;  // this is for set file uploaded key to rowinfo
          this.preonboardfilesuploaded = response?.filesuploaded;  // this is for set file uploaded key to preonboardfilesuploaded
          this.documentCollectionMasterInfo['idAttachmentsOnboard'] = JSON.parse(JSON.stringify(response.idAttachmentsOnboard));
          this.isLoaderEnabled = false;
          this.iddoceditable = false;
          this.SelectedTabChange(false);
          this.patchDocumentCollectionForm(this.documentCollectionMasterInfo);
          this.snackBarUtil.triggerSnackBar(SnackbarConstants.FILES_UPLOADED_MESSAGE)
          this.onboardCreateForm.get('idattachments').markAsPristine();
        } else {
          this.isLoaderEnabled = false;
          this.snackBarUtil.triggerSnackBar(SnackbarConstants.ERROR_MESSAGE)
        }
      },
      error => {
        this.isLoaderEnabled = false;
        this.snackBarUtil.triggerSnackBar(SnackbarConstants.ERROR_MESSAGE)
      });
    this.userService.isCandProfileEditActive(false);//For Hide Language Change while Canidate Edit

  }

  submitFormsAccordion() {
    this.isLoaderEnabled = true;
    /**Get Id & Status from candidate input */
    if (this.rowInfo) {
      this.onboardCreateForm.controls['id'].setValue(this.rowInfo.id);
      this.onboardCreateForm.controls['status'].setValue(this.rowInfo.candidatestatus);
      if (this.rowInfo.created_by != null && this.rowInfo.created_by != undefined && this.rowInfo.created_by != '') {
        this.onboardCreateForm.controls['modified_by'].setValue(this.loggedInOrgID);
        this.onboardCreateForm.controls['modified_on'].setValue(new Date());
      }
      else {
        this.onboardCreateForm.controls['created_by'].setValue(this.loggedInOrgID);
        this.onboardCreateForm.controls['createdon'].setValue(new Date());
      }
    }
    let compensationdetailsfiles = {}
    let formsfiles =
    {
      employmentapplicationformBytes: this.onboardCreateForm.get('forms').get('employmentapplicationform').value,
      bgvformBytes: this.onboardCreateForm.get('forms').get('bgvform').value,
      joiningformBytes: this.onboardCreateForm.get('forms').get('joiningform').value,
      pfuanBytes: this.onboardCreateForm.get('forms').get('pfuan').value,
      medicalreportBytes: this.onboardCreateForm.get('forms').get('medicalreport').value,
      conflictofinterestformBytes: this.onboardCreateForm.get('forms').get('conflictofinterestform').value,
      confidentialityformBytes: this.onboardCreateForm.get('forms').get('confidentialityform').value,
    }
    let idattachments = {}
    let onboardFiles =
    {
      candiateid: this.rowInfo.id,
      orgid: this.loggedInOrgID,
      filesuploaded: this.rowInfo.uploadedfiles,
      compensationDetailsOnboard: compensationdetailsfiles,
      formsOnboard: formsfiles,
      idAttachmentsOnboard: idattachments
    }

    this.onboardService.uploadpreloadFormFiles(onboardFiles).subscribe(
      (response: any) => {
        this.rowInfo.uploadedfiles = response.filesuploaded;  // this is for set file uploaded key to rowinfo
        this.preonboardfilesuploaded = response.filesuploaded;  // this is for set file uploaded key to preonboardfilesuploaded
        this.documentCollectionMasterInfo['formsOnboard'] = JSON.parse(JSON.stringify(response.formsOnboard));
        this.isLoaderEnabled = false;
        this.formsdoceditable = false;
        this.SelectedTabChange(false);
        this.patchDocumentCollectionForm(this.documentCollectionMasterInfo);
        this.snackBarUtil.triggerSnackBar(SnackbarConstants.FILES_UPLOADED_MESSAGE)
        this.onboardCreateForm.get('forms').markAsPristine();
      },
      error => {
        this.isLoaderEnabled = false;
        this.snackBarUtil.triggerSnackBar(SnackbarConstants.ERROR_MESSAGE)
      });
    this.userService.isCandProfileEditActive(false);//For Hide Language Change while Canidate Edit
  }

  submitEduExpAccordion(module) {
    // Only when the form is Valid
    this.experienceproof = this.onboardCreateForm.get('eduexpattachments').get('experienceproof') as FormArray;
    this.educationproof = this.onboardCreateForm.get('eduexpattachments').get('educationproof') as FormArray;
    let experienceproofFileNameArray = this.experienceproof?.value?.map(name => name.filename);
    const isSameFilenameInExperience = this.experienceproof?.length !== new Set(experienceproofFileNameArray)?.size;
    let educationproofFileNameArray = this.educationproof?.value?.map(name => name.filename);
    const isSameFilenameInEducation = this.educationproof.length !== new Set(educationproofFileNameArray)?.size;
    if ((module === 'education' && this.educationproof.valid && isSameFilenameInEducation === false) || (module === 'experience' && this.experienceproof.valid && isSameFilenameInExperience === false)) {
      this.isLoaderEnabled = true;
      /**Get Id & Status from candidate input */
      if (this.rowInfo) {
        this.onboardCreateForm.controls['id'].setValue(this.rowInfo.id);
        this.onboardCreateForm.controls['status'].setValue(this.rowInfo.candidatestatus);
        if (this.rowInfo.created_by != null && this.rowInfo.created_by != undefined && this.rowInfo.created_by != '') {
          this.onboardCreateForm.controls['modified_by'].setValue(this.loggedInOrgID);
          this.onboardCreateForm.controls['modified_on'].setValue(new Date());
        }
        else {
          this.onboardCreateForm.controls['created_by'].setValue(this.loggedInOrgID);
          this.onboardCreateForm.controls['createdon'].setValue(new Date());
        }
      }
      let eduexpattachments = this.onboardCreateForm.get('eduexpattachments').value;
      eduexpattachments.educationproof = eduexpattachments.educationproof.filter(element => element.filename != '' && element.filename != null && element.filecontent != null && element.filecontent != '');
      eduexpattachments.experienceproof = eduexpattachments.experienceproof.filter(element => element.filename != '' && element.filename != null && element.filecontent != null && element.filecontent != '');
      let onboardFiles =
      {
        candiateid: this.rowInfo.id,
        orgid: this.loggedInOrgID,
        filesuploaded: this.rowInfo.uploadedfiles,
        compensationDetailsOnboard: {},
        formsOnboard: {},
        idAttachmentsOnboard: {},
        eduExpAttachmentsOnboard: eduexpattachments
      }
      this.onboardService.uploadEduExpFiles(onboardFiles).subscribe(
        (response: any) => {
          this.isLoaderEnabled = false;
          this.documentCollectionMasterInfo['eduExpAttachmentsOnboard'] = JSON.parse(JSON.stringify(response.eduExpAttachmentsOnboard));
          this.rowInfo.uploadedfiles = response.filesuploaded;  // this is for set file uploaded key to rowinfo
          this.preonboardfilesuploaded = response.filesuploaded;  // this is for set file uploaded key to preonboardfilesuploaded
          this.isLoaderEnabled = false;
          this.eduexpdoceditable = false;
          this.SelectedTabChange(false);
          this.patchDocumentCollectionForm(this.documentCollectionMasterInfo);
          this.snackBarUtil.triggerSnackBar(SnackbarConstants.FILES_UPLOADED_MESSAGE)
          this.onboardCreateForm.get('eduexpattachments').markAsPristine();
          setTimeout(() => { //delay assign this.initialFormValue for candidatedata array
            this.initialFormValue = JSON.parse(JSON.stringify(this.onboardCreateForm.value)); // Deep clone
          }, 1000);
          // when in view screen update data 
        },
        error => {
          this.isLoaderEnabled = false;
          this.snackBarUtil.triggerSnackBar(SnackbarConstants.ERROR_MESSAGE)
        });
      this.userService.isCandProfileEditActive(false);//For Hide Language Change while Canidate Edit

    }
    else {
      if (module === 'education') {
        if (this.educationproof instanceof FormArray) {
          // Mark all controls inside the FormArray as touched
          this.educationproof.controls.forEach(control => control.markAllAsTouched());
        }
      }
      else {
        if (this.experienceproof instanceof FormArray) {
          // Mark all controls inside the FormArray as touched
          this.experienceproof.controls.forEach(control => control.markAllAsTouched());
        }
      }
      this.snackBarUtil.triggerSnackBar(SnackbarConstants.RESOLVE_ISSUES_MESSAGE)
    }
  }

  addChip(event: MatChipInputEvent, key, formcontrolname: string): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim() && this[key].indexOf(value) === -1) {
      this[key].push(value.trim());
    }
    if (input) {
      input.value = '';
    }
  }

  removeChip(val, key, formcontrolname: string) {
    const index = this[key].indexOf(val);
    if (index >= 0) {
      this[key].splice(index, 1);
    }
  }

  resetFormValidationMetrics() {
    this.errorFields = [];
    this.showErrorFields = true;
  }


  addNewLanguagesFormArrayField() {
    return this.formBuilder.group({
      language: new FormControl('', [Validators.required, Validators.maxLength(30), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5)]),
      read: new FormControl(''),
      write: new FormControl(''),
      speak: new FormControl(''),
    });
  }


  //Languages Form Array
  addNewLanguagesFormArrayFieldBasedOnData(data) {
    return this.formBuilder.group({
      // language: new FormControl(data.language, [Validators.pattern(validationConstants.REGEX_TEXT_TYPE1), Validators.maxLength(30)]),
      language: new FormControl(data.language, [Validators.required, Validators.maxLength(30), Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5)]),
      read: new FormControl(data.read),
      write: new FormControl(data.write),
      speak: new FormControl(data.speak),
    });
  }


  //Education Form Array 
  // addNewEducationFormArrayField() {
  //   return this.formBuilder.group({
  //     id: new FormControl(null),
  //     degreename: new FormControl('', [Validators.required]),
  //     specialization: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
  //     percent: new FormControl(null, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(5)]),
  //     university: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(60)]),
  //     yearofpassing: new FormControl(null, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4)]),
  //     type: new FormControl(''),
  //     status: new FormControl(''),
  //   });
  // }

  // addNewEducationFieldBasedOnData(data) {
  //   return this.formBuilder.group({
  //     id: new FormControl(data.id),
  //     degreename: new FormControl(data.degreename, [Validators.required]),
  //     specialization: new FormControl(data.specialization, [Validators.maxLength(50)]),
  //     percent: new FormControl(data.percent, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(5)]),
  //     university: new FormControl(data.university, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(60)]),
  //     yearofpassing: new FormControl(data.yearofpassing, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4)]),
  //     type: new FormControl(data.type),
  //     status: new FormControl(''),
  //   });
  // }

  //Experience Form Array
  // addNewExperienceFormArrayField() {
  //   return this.formBuilder.group({
  //     id: new FormControl(null),
  //     organization: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
  //     designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
  //     startdt: new FormControl(''),
  //     enddt: new FormControl(''),
  //     ctcvaluestring: new FormControl('', [Validators.maxLength(10)]),
  //     ctcvalue: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(18)]),
  //     ctctype: new FormControl(),
  //     type: new FormControl(''),
  //     status: new FormControl(''),
  //   });
  // }

  // addNewExperienceFieldBasedOnData(data) {
  //   return this.formBuilder.group({
  //     id: new FormControl(data.id),
  //     organization: new FormControl(data.organization, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
  //     designation: new FormControl(data.designation, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
  //     startdt: new FormControl(data.startdt),
  //     enddt: new FormControl(data.enddt),
  //     ctcvalue: new FormControl(data.ctcvaluestring, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(8)]),
  //     ctctype: new FormControl(data.ctctype),
  //     type: new FormControl(data.type),
  //     status: new FormControl(''),
  //   });

  // }

  // //Skill Form Array
  // addNewSkillFormArrayField() {
  //   return this.formBuilder.group({
  //     id: new FormControl(null),
  //     skill: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
  //     version: new FormControl('', []),
  //     yrsworked: new FormControl(''),
  //     lastused: new FormControl(''),
  //     proficiency: new FormControl('', []),
  //     status: new FormControl('', []),
  //   });
  // }

  // addNewSkillFormArrayFieldBasedOnData(data) {
  //   return this.formBuilder.group({
  //     id: new FormControl(data.id),
  //     skill: new FormControl(data.skill, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
  //     version: new FormControl(data.version, []),
  //     yrsworked: new FormControl(data.yrsworked),
  //     lastused: new FormControl(data.lastused),
  //     proficiency: new FormControl(data.proficiency, []),
  //     status: new FormControl('', []),
  //   });
  // }

  //Reference Form Array
  addNewReferenceFormArrayField(dialcode) {
    return this.formBuilder.group({
      name: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
      designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
      organization: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
      relationtype: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
      dialcode: new FormControl(dialcode),
      mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
      contact: new FormControl(''),
      email: new FormControl('', [Validators.email])
    });

  }

  addNewReferenceFormArrayFieldBasedOnData(data) {
    return this.formBuilder.group({
      name: new FormControl(data.name, [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
      designation: new FormControl(data.designation, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
      organization: new FormControl(data.organization, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
      relationtype: new FormControl(data.relationtype, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
      dialcode: new FormControl(''),
      mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
      contact: new FormControl(data.contact),
      email: new FormControl(data.email, [Validators.email])
    });
  }

  //Siblings Form Array
  addNewSiblingsFormArrayField() {

    return this.formBuilder.group({
      name: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
      dob: new FormControl(''),
      gender: new FormControl(''),
      address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)])
    });

  }
  addNewSiblingsFormArrayFieldBasedOnData(data) {
    return this.formBuilder.group({
      name: new FormControl(data.name, [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
      dob: new FormControl(data.dob),
      gender: new FormControl(data.gender),
      address: new FormControl(data.address, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)])
    });
  }

  //Children Form Array
  addNewChildrenFormArrayField() {
    return this.formBuilder.group({
      name: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
      dob: new FormControl(''),
      gender: new FormControl(''),
      address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)])
    });
  }

  addNewChildrenFormArrayFieldBasedOnData(data) {

    return this.formBuilder.group({
      name: new FormControl(data.name, [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
      dob: new FormControl(data.dob),
      gender: new FormControl(data.gender),
      address: new FormControl(data.address, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)])
    });
  }

  //Relative Form Array
  // addNewRelativeFormArrayField() {
  //   return this.formBuilder.group({
  //     name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
  //     empid: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
  //     designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
  //     email: new FormControl('', [Validators.email]),
  //     dialcode: new FormControl(),
  //     mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
  //     mobino: new FormControl(''),
  //     location: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
  //     department: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
  //   });
  // }

  // addNewRelativeFormArrayFieldBasedOnData(data) {

  //   return this.formBuilder.group({
  //     name: new FormControl(data.name, [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
  //     empid: new FormControl(data.empid, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
  //     designation: new FormControl(data.designation, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
  //     email: new FormControl(data.email, [Validators.email]),
  //     dialcode: new FormControl(''),
  //     mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
  //     mobino: new FormControl(data.mobino),
  //     location: new FormControl(data.location, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
  //     department: new FormControl(data.department, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
  //   });
  // }

  expandDownloadDialog() {
    let dialogRef;
    dialogRef = this.dialog.open(ZipFileDownloadDialog, {
      width: '635px',
    });
  }

  @Output()
  selectedTabChange = new EventEmitter<any>();
  SelectedTabChange(value) {
    this.selectedTabChange.emit(value);
  }

  selectedIndex: Number = 0;
  tabChange(tab, event: any) {
    // When Tab Change + When the Edit is active + form is dirty 
    if (this.selectedIndex !== tab.selectedIndex &&
      ((this.compensationdoceditable || this.iddoceditable || this.eduexpdoceditable || this.formsdoceditable) && this.onboardCreateForm.dirty)) {
      tab.selectedIndex = this.selectedIndex;
      let dialogRef;
      dialogRef = this.dialog.open(TabRestrictDialog, {
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe(data => {
        if (data !== this.selectedIndex) {
          if (this.compensationdoceditable || this.iddoceditable || this.eduexpdoceditable || this.formsdoceditable) {
            if (this.compensationdoceditable) {
              this.cancelFileEdit('compensationdetails');
              this.compensationdoceditable = false;
            }
            if (this.iddoceditable) {
              this.cancelFileEdit('idattachments');
              this.iddoceditable = false;
            }
            if (this.eduexpdoceditable) {
              this.cancelFileEdit('eduexpattachments');
              this.eduexpdoceditable = false
            }
            if (this.formsdoceditable) {
              this.cancelFileEdit('forms');
              this.formsdoceditable = false
            }
            this.selectedIndex;
          }
        } else {
          this.selectedIndex = tab.selectedIndex;
        }
      });
    }
  }

  issuesResolved() {
    let dialogRef = this.dialog.open(FormSubmissionErrorsDialog, {
      width: '635px',
      data: { error: this.errorFields, orgform: this.orgBasedOnboardFormsJson },
    });
    dialogRef.afterClosed().subscribe(data => {
    })
  }

  checkIfFormGroupIsValid() {
    this.errorFields = [];
    this.validationHighlightsUtil.errorFields = [];
    this.errorFields = this.validationHighlightsUtil.validateAllFormControl(this.onboardCreateForm, null);
  }

  focusInput(inputName: string) {
    setTimeout(() => {
      switch (inputName) {
        case 'refdialcodeSearch':
          this.refdialcodeSearch.nativeElement.focus();
          break;
        default:
          console.warn(`No input found for ${inputName}`);
          break;
      }
    });
  }
}
